<template>
  <Modal :title="t.guest_registration" identifier="lunchCheckIn" is-full-mobile>
    <div class="flex-grow-1 d-flex flex-column text-left">
      <Alert v-if="success" :title="t.form.success_headline" variant="success">
        {{ t.form.success_text }}
      </Alert>
      <fragment v-if="!success">
        <p class="text-muted mb-3">
          {{ t.intro }}
        </p>
        <form @submit.prevent="submit" class="d-flex flex-column w-100">
          <FormInput
            v-model="formData.name"
            :label="t.form.name"
            :placeholder="t.form.name_placeholder"
            name="name"
            type="text"
            required
          />
          <FormInput
            v-model="formData.phone"
            :label="t.form.phone"
            :placeholder="t.form.phone_placeholder"
            name="phone"
            type="tel"
          />
          <FormInput
            v-model="formData.email"
            :label="t.form.email"
            :placeholder="t.form.email_placeholder"
            name="email"
            type="email"
          />
          <FormInput
            v-model="formData.address"
            :label="t.form.address"
            :placeholder="t.form.address_placeholder"
            name="address"
            type="text"
          />
          <button :disabled="!isValid" class="btn btn-success btn-lg" type="submit">
            {{ loading ? t.form.button_loading_text : t.form.button_text }}
          </button>
        </form>
      </fragment>
    </div>
  </Modal>
</template>

<script>
import Modal from "./Modal";
import FormInput from "./FormInput";
import Alert from "./Alert";
import { mapActions } from "vuex";

export default {
  name: "LunchCheckIn",
  components: {
    Modal,
    Alert,
    FormInput,
  },
  props: {
    t: {
      type: Object,
      required: true,
    },
    apiUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        name: "",
        phone: "",
        email: "",
        address: "",
      },
      success: false,
      loading: false,
    };
  },
  computed: {
    isValid() {
      return (
        this.formData.name && (this.formData.email || this.formData.address || this.formData.phone)
      );
    },
  },
  methods: {
    ...mapActions(["postAsync"]),
    submit(e) {
      this.loading = true;
      this.postAsync({ path: this.apiUrl, formData: new FormData(e.target) }).then(() => {
        this.success = true;
        this.loading = false;
      });
    },
  },
};
</script>
